import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Categoria} from "./categroia";
import {CategoriaService} from "../Services/categoria.service";

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: ['./categoria.component.css']
})
export class CategoriaComponent implements OnInit {

  msgs: Message[] = [];
  formCategoria : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  CategoriasRegistrados:Categoria[];
  CategoriaSeleccionado:Categoria;
  tipoGuardado = '';


  constructor(private servicioCategoria:CategoriaService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesCategoria();
    this.Cancelar();
    this.listarCategorias();
  }

  crearControlesCategoria(){
    this.formCategoria = this.fb.group({
        nombre:['',Validators.required],
      }
    );

  }
  nuevoCategoria(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formCategoria.enable();
    this.formCategoria.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formCategoria.reset();
    this.formCategoria.disable();
    this.panelRequeridos = false;
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoCategoria(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioCategoria.putCategoria(this.formCategoria.value,this.CategoriaSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarCategorias();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioCategoria.addCategoria(this.formCategoria.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarCategorias();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarCategorias(){
    this.loading = true;
    this.servicioCategoria.getCategoria()
      .subscribe(
        rt => {
          this.CategoriasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarCategoria(item:Categoria){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formCategoria.enable();
    this.panelRequeridos = true;
    this.CategoriaSeleccionado = item;
    this.CategoriaDetalle(item);
    this.tipoGuardado = 'editar';
  }
  CategoriaDetalle(item:Categoria):void {
    this.formCategoria.patchValue({
      id:item.id,
      nombre:item.nombre,
    });
  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/categoria/categoria.component.ts